"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchPolicy = void 0;
// We don't actually do anything with this.
var FetchPolicy;
(function (FetchPolicy) {
    FetchPolicy["CACHE_AND_NETWORK"] = "cache-and-network";
    FetchPolicy["CACHE_FIRST"] = "cache-first";
    FetchPolicy["CACHE_ONLY"] = "cache-only";
    FetchPolicy["NETWORK_ONLY"] = "network-only";
    FetchPolicy["NO_CACHE"] = "no-cache";
})(FetchPolicy = exports.FetchPolicy || (exports.FetchPolicy = {}));
//# sourceMappingURL=client-types.js.map